import { StackProps } from "./Stack";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { toPx } from "@mrocket/styles";


const keysOfProps = [
  'direction',
  'gap',
  'grow',
  'shrink',
  'wrap',
  'align'
]

export const StackRoot = styled('div', {
  shouldForwardProp: props => !keysOfProps.includes(props)
})<StackProps>`
  display: flex;
  flex-direction: ${props => props.direction};
  flex-grow: ${props => props.grow};
  flex-shrink: ${props => props.shrink};
  flex-wrap: ${props => props.wrap};
  align-items: ${props => props.align};
  justify-content: ${props => props.justify};
  ${({gap, wrap, direction}) => !gap ? undefined :  (!wrap || wrap !== 'wrap' && wrap !== 'wrap-reverse') ? css`
    & > :not(styles) ~ :not(styles) {
      margin-top: ${direction === 'column' && toPx(gap)};
      margin-bottom: ${direction === 'column-reverse' && toPx(gap)};
      margin-left: ${toPx(gap)};
      margin-right: ${direction === 'row-reverse' && toPx(gap)};
      };
    }`
    : css`gap: ${toPx(gap)}`
  };
`